import React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "../../../lib/utils";

export function InventoryTabs({ activeTab, onTabChange }) {
  const { t } = useTranslation();

  return (
    <div className="flex border-b border-[var(--color-text-border)]/65 font-sans shrink-0">
      <button
        type="button"
        className={cn(
          "py-3 px-5 text-sm font-bold border-b-2 transition cursor-pointer -mb-[2px]",
          activeTab === "position"
            ? "border-[var(--color-primary)] text-[var(--color-primary)]"
            : "border-transparent text-[var(--color-text-secondary)] hover:text-foreground"
        )}
        onClick={() => onTabChange("position")}
      >
        {t("inventory.stockPosition")}
      </button>

      <button
        type="button"
        className={cn(
          "py-3 px-5 text-sm font-bold border-b-2 transition cursor-pointer -mb-[2px] flex items-center gap-1.5",
          activeTab === "journal"
            ? "border-[var(--color-primary)] text-[var(--color-primary)]"
            : "border-transparent text-[var(--color-text-secondary)] hover:text-foreground"
        )}
        onClick={() => onTabChange("journal")}
      >
        <span>{t("inventory.stockJournal")}</span>
        <span className={cn(
          "h-4.5 min-w-4.5 px-1 rounded-full text-[10px] font-extrabold flex items-center justify-center font-mono",
          activeTab === "journal" ? "bg-[var(--color-primary)]/10 text-[var(--color-primary)]" : "bg-gray-100 text-gray-500"
        )}>
          27
        </span>
      </button>
    </div>
  );
}
